// EDIT HERE: hero messaging. Other text lives in src/components and src/data/siteData.js.
export const HERO_COPY = {
  heading: "Better Energy Rates.",
  accent: "Lower Business Costs.",
  subtitle: "BlueSettle secures the lowest commercial energy prices that your business deserves, from a network of 60+ suppliers nationwide. Reduce business energy costs with better rates, clearer choices, and no obligation to switch.",
  primaryButton: "Analyze My Bill",
  secondaryButton: "Calculate Potential Savings",
};
